import { render } from "./OvApplicationsView.vue?vue&type=template&id=29a96843&scoped=true"
import script from "./OvApplicationsView.vue?vue&type=script&lang=js"
export * from "./OvApplicationsView.vue?vue&type=script&lang=js"

import "./OvApplicationsView.vue?vue&type=style&index=0&id=29a96843&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29a96843"]])

export default __exports__